import { Fragment, useState } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, SelectorIcon } from "@heroicons/react/solid";
import { checkForOverride, linearGradient } from "./helpers/theme";

function classNames(...classes) {
	return classes.filter(Boolean).join(" ");
}

export default function ThemeSelectorDropdown({
	themes,
	selectedTheme,
	projectDefaultTheme,
	onChange,
}) {
	const [selected, setSelected] = useState(selectedTheme);

	const people = Object.entries(themes).map(([id, theme]) => {
		if (id === projectDefaultTheme) {
			return {
				...theme,
				id: id,
				name: `${theme.name} (Project default)`,
			};
		}
		return {
			...theme,
			id: id,
			name: theme.name,
		};
	});

	const handleOnChange = (change) => {
		setSelected(change);
		onChange(change.id);
	};

	return (
		<Listbox value={selected} onChange={handleOnChange}>
			{({ open }) => (
				<>
					<div className="mt-1 relative flex-1">
						<Listbox.Button className="relative w-full bg-gray-700 cursor-pointer rounded-md shadow-sm pl-3 pr-10 py-2 text-left focus:outline-none focus:ring focus:ring-main-500 focus:border-main-500 sm:text-sm">
							<div className="flex items-center">
								<span
									className={`p-1 w-10 text-center
                                                rounded-${selected?.background?.rounding}
                                            `}
									style={{
										background: linearGradient(
											selectedTheme,
											null,
											null,
											"background"
										),
										color: selected?.h1?.colour,
										fontFamily: selected?.font?.family,
										borderTop: `${
											checkForOverride(
												selectedTheme,
												null,
												null,
												"border",
												"sides"
											)[0] === "1"
												? selected?.border.size
												: 0
										}vw ${checkForOverride(
											selectedTheme,
											null,
											null,
											"border",
											"style"
										)} ${checkForOverride(
											selectedTheme,
											null,
											null,
											"border",
											"colour"
										)}`,
										borderBottom: `${
											checkForOverride(
												selectedTheme,
												null,
												null,
												"border",
												"sides"
											)[1] === "1"
												? selected?.border.size
												: 0
										}vw ${checkForOverride(
											selectedTheme,
											null,
											null,
											"border",
											"style"
										)} ${checkForOverride(
											selectedTheme,
											null,
											null,
											"border",
											"colour"
										)}`,
										borderLeft: `${
											checkForOverride(
												selectedTheme,
												null,
												null,
												"border",
												"sides"
											)[2] === "1"
												? selected?.border.size
												: 0
										}vw ${checkForOverride(
											selectedTheme,
											null,
											null,
											"border",
											"style"
										)} ${checkForOverride(
											selectedTheme,
											null,
											null,
											"border",
											"colour"
										)}`,
										borderRight: `${
											checkForOverride(
												selectedTheme,
												null,
												null,
												"border",
												"sides"
											)[3] === "1"
												? selected?.border.size
												: 0
										}vw ${checkForOverride(
											selectedTheme,
											null,
											null,
											"border",
											"style"
										)} ${checkForOverride(
											selectedTheme,
											null,
											null,
											"border",
											"colour"
										)}`,
									}}
								>
									Aa
								</span>
								<span
									className={classNames(
										selected ? "font-semibold" : "font-normal",
										"ml-3 block truncate"
									)}
								>
									{selected?.name}{" "}
									{/* {selected?.id === projectDefaultTheme && "(Project default)"} */}
								</span>
							</div>
							<span className="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
								<SelectorIcon
									className="h-5 w-5 text-gray-400"
									aria-hidden="true"
								/>
							</span>
						</Listbox.Button>

						<Transition
							show={open}
							as={Fragment}
							leave="transition ease-in duration-100"
							leaveFrom="opacity-100"
							leaveTo="opacity-0"
						>
							<Listbox.Options className="absolute bg-gray-700 z-10 mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base overflow-auto focus:outline-none sm:text-sm">
								{people.map((person) => (
									<Listbox.Option
										key={person?.id}
										className={({ active }) =>
											classNames(
												active ? "text-white bg-gray-800" : "text-gray-900",
												"cursor-pointer select-none relative py-2 pl-3 pr-9 focus:outline-none"
											)
										}
										value={person}
									>
										{({ active }) => {
											return (
												<>
													<div className="flex items-center">
														<span
															className={`p-1 w-10 text-center
                                                                        rounded-${person?.background?.rounding}
                                                                    `}
															style={{
																background: linearGradient(
																	person,
																	null,
																	null,
																	"background"
																),
																color: person?.h1?.colour,
																fontFamily: person?.font?.family,
																borderTop: `${
																	checkForOverride(
																		person,
																		null,
																		null,
																		"border",
																		"sides"
																	)[0] === "1"
																		? person?.border.size
																		: 0
																}vw ${checkForOverride(
																	person,
																	null,
																	null,
																	"border",
																	"style"
																)} ${checkForOverride(
																	person,
																	null,
																	null,
																	"border",
																	"colour"
																)}`,
																borderBottom: `${
																	checkForOverride(
																		person,
																		null,
																		null,
																		"border",
																		"sides"
																	)[1] === "1"
																		? person?.border.size
																		: 0
																}vw ${checkForOverride(
																	person,
																	null,
																	null,
																	"border",
																	"style"
																)} ${checkForOverride(
																	person,
																	null,
																	null,
																	"border",
																	"colour"
																)}`,
																borderLeft: `${
																	checkForOverride(
																		person,
																		null,
																		null,
																		"border",
																		"sides"
																	)[2] === "1"
																		? person?.border.size
																		: 0
																}vw ${checkForOverride(
																	person,
																	null,
																	null,
																	"border",
																	"style"
																)} ${checkForOverride(
																	person,
																	null,
																	null,
																	"border",
																	"colour"
																)}`,
																borderRight: `${
																	checkForOverride(
																		person,
																		null,
																		null,
																		"border",
																		"sides"
																	)[3] === "1"
																		? person?.border.size
																		: 0
																}vw ${checkForOverride(
																	person,
																	null,
																	null,
																	"border",
																	"style"
																)} ${checkForOverride(
																	person,
																	null,
																	null,
																	"border",
																	"colour"
																)}`,
															}}
														>
															Aa
														</span>
														<span
															className={classNames(
																active ? "font-normal" : "font-normal",
																"ml-3 block truncate text-gray-100"
															)}
														>
															{person?.name}
														</span>
													</div>

													{person?.name.includes(selectedTheme?.name) ? (
														<span
															className={classNames(
																"absolute inset-y-0 right-0 flex items-center pr-4 text-gray-400"
															)}
														>
															<CheckIcon
																className="h-5 w-5"
																aria-hidden="true"
															/>{" "}
														</span>
													) : null}
												</>
											);
										}}
									</Listbox.Option>
								))}
							</Listbox.Options>
						</Transition>
					</div>
				</>
			)}
		</Listbox>
	);
}
